var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBadge({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.99 9.825c-.082.689-.693 1.175-1.377 1.175h-3.226c-.684 0-1.296-.486-1.378-1.175H6V24.2h20V9.825h-7.01zM16.965 9.2A.999.999 0 0 1 17 8.71V5.8h-2v2.907a.999.999 0 0 1 .036.493h1.93zM19 8.025h7.12c1.039 0 1.88.85 1.88 1.889v14.238c0 1.04-.841 1.889-1.88 1.889H5.88c-1.039 0-1.88-.85-1.88-1.89V9.915c0-1.04.841-1.889 1.88-1.889H13V5.331c0-.773.652-1.334 1.387-1.334h3.226c.735 0 1.387.562 1.387 1.334v2.694zm3.619 8.972c1.358.71 2.281 2.28 2.281 4.067v.802a.9.9 0 0 1-1.8 0v-.802c0-1.501-.983-2.668-2.105-2.668h-1.99c-1.122 0-2.105 1.167-2.105 2.668v.802a.9.9 0 0 1-1.8 0v-.802c0-1.786.923-3.357 2.28-4.067a3.15 3.15 0 1 1 5.769-1.751c0 .648-.195 1.25-.53 1.751zm-2.62-.4a1.35 1.35 0 1 0 .002-2.7 1.35 1.35 0 0 0-.002 2.7zm-12-1.7a.9.9 0 1 1 0-1.8h6a.9.9 0 1 1 0 1.8H8zm0 3.001a.9.9 0 1 1 0-1.8h5a.9.9 0 1 1 0 1.8H8z",
    fill: "#737373",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadge);
export default __webpack_public_path__ + "static/media/badge.edc49b476bc9285e55d19ea2c6345647.svg";
export { ForwardRef as ReactComponent };